import React from 'react';
import '../css/aboutus.css';

const directors = [
  {
    name: 'Vidyotma Tiwari',
    image: `${process.env.PUBLIC_URL}/images/Vidya.jpg`,
    bio: "Vidyotma Tiwari brings over a decade of robust experience in technology and business leadership. Her strategic vision and operational acumen drive Manvidia's growth and innovation. Possessing an MBA in HR Generalist, she blends technical insight with a deep understanding of organizational dynamics. Her leadership fosters a culture of excellence, empowering teams to achieve ambitious goals. Vidyotma's expertise spans diverse technological domains, coupled with a proven track record of successful project delivery and business transformation. Her commitment to fostering talent and driving sustainable growth makes her a valuable asset to Manvidia.",
  },
  {
    name: 'Mandavi Kumari',
    image: `${process.env.PUBLIC_URL}/images/Mandavi.jpg`,
    bio: "Mandavi Kumari is a driving force in the company's strategic planning and business development. Her academic credentials are exceptionally strong, boasting double masters from prestigious institutions like Banaras Hindu University and Jamia Millia Islamia. This robust educational foundation equips her with a unique blend of theoretical knowledge and practical insight. Mandavi's expertise is pivotal in shaping Manvidia's growth trajectory, focusing on identifying new opportunities and fostering sustainable business expansion. Her dedication to strategic innovation and market penetration makes her an invaluable leader within the organization.",
  },
];

const AboutUs = () => {
  return (
    <div>
      <section className="about-hero">
        <div className="page">
          <span className="eyebrow">Who we are</span>
          <h1>Future Powered by AI.</h1>
        </div>
      </section>

      {/* Why Manvidia */}
      <section className="section">
        <div className="page">
          <div className="section-heading" data-aos="fade-up">
            <span className="eyebrow">Why Manvidia</span>
            <h2 className="section-title">Pioneering responsible AI automation</h2>
          </div>
          <article className="feature" data-aos="fade-up">
            <div className="feature-media">
              <img src={`${process.env.PUBLIC_URL}/images/discoverManvidia.png`} alt="Responsible AI" />
            </div>
            <div className="feature-body">
              <p>
                MANVIDIA pioneers ethical AI solutions, empowering businesses with efficiency. We craft intelligent AI agents that revolutionize workflows, driving productivity and innovation. Our commitment lies in developing responsible AI, ensuring transparency and fairness.
              </p>
              <p>
                Leveraging cutting-edge technology, MANVIDIA delivers tailored solutions that optimize operations and foster growth. We prioritize understanding your unique needs, building AI that aligns with your values and enhances your business's capabilities.
              </p>
              <p className="about-tagline">
                With MANVIDIA, embrace the future of AI, where ethical design meets practical application, transforming your business landscape.
              </p>
            </div>
          </article>
        </div>
      </section>

      {/* Directors */}
      <section className="section">
        <div className="page">
          <div className="section-heading" data-aos="fade-up">
            <span className="eyebrow">Leadership</span>
            <h2 className="section-title">Meet Our Directors</h2>
          </div>
          <div className="directors-grid">
            {directors.map((director, index) => (
              <article className="director-card" key={director.name} data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="director-header">
                  <img src={director.image} alt={director.name} className="director-photo" />
                  <div>
                    <h3>{director.name}</h3>
                    <span className="director-role">Director</span>
                  </div>
                </div>
                <p>{director.bio}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
